let ROUTE_AFTER_LOGIN
let ROUTE_AFTER_LOGOUT
let router

if (process.env.PLATFORM === 'alumnier') {
  router = require('./alumnier')
} else if (process.env.PLATFORM === 'iceverg') {
  router = require('./iceverg')
} else if (process.env.PLATFORM === '1cvrg') {
  router = require('./1cvrg')
} else if (process.env.PLATFORM === 'happyjob') {
  router = require('./happyjob')
}

ROUTE_AFTER_LOGIN = router.ROUTE_AFTER_LOGIN
ROUTE_AFTER_LOGOUT = router.ROUTE_AFTER_LOGOUT

export default router.default
export {
  ROUTE_AFTER_LOGIN,
  ROUTE_AFTER_LOGOUT
}



// WEBPACK FOOTER //
// ./src/router/index.js